import { VStack } from "@chakra-ui/react"
import React from "react"
import { CreateTagForm } from "../../forms"

export const CreateTag: React.FC = () => {
	return (
		<VStack w="full" maxW="sm" spacing={6}>
			<CreateTagForm />
		</VStack>
	)
}
